
  import {Component, Vue} from "vue-property-decorator";
  import {ICar} from "@/modules/Car/interfaces/car.interface";

  @Component({})
  export default class PrintCarList extends Vue {
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    fileName = 'Список автомобилей';
    carStatusesMap = {};
    dataProps = [
      { label: 'Номер',       prop: 'carNumber',    },
      { label: 'Статус',      prop: 'carStatusId',  },
      { label: 'ФИО',         prop: 'persName',     },
      { label: 'Док',         prop: 'tmPersonId',   },
      { label: 'Корпорация',  prop: 'corpId',       },
      { label: 'Парковка',    prop: 'parkName',     },
      { label: 'Дата начала', prop: 'dateBeg',      },
      { label: 'Заезд',       prop: 'dateIn',       },
      { label: 'Выезд',       prop: 'dateOut',      },
      { label: 'Время',       prop: 'timePark',     },
      { label: 'Сумма',       prop: 'balance',      },
      { label: 'Дней',        prop: 'dayInMonth',   },
      { label: 'Комментарий', prop: 'tarifId',      },
    ];

    get carList(): ICar.IEntity[] { return this.$store.getters['carList/sortedList']; }

    mounted() {
      const carStatusesMap = this.$store.state.book.books.carStatuses;

      carStatusesMap.forEach((item) => {
        Vue.set(this.carStatusesMap, item.id, item);
      });
    }

    printCellValue(car: ICar.IEntity, prop: string) {
      let valueByProp = {
        'carNumber': car.carNumber,
        'carStatusId': this.carStatusesMap[car.carStatusId].name,
        'persName': `${car.persName ? car.persName : ''}${car.guestFlag ? ' (гость)' : ''}`,
        'tmPersonId': car.tmPersonId,
        'corpId': car.corpName,
        'parkName': car.parkName,
        'dateBeg': this.printDate(car.dateBeg, false),
        'dateIn': this.printDate(car.dateIn),
        'dateOut': this.printDate(car.dateOut),
        'timePark': car.timePark,
        'balance': this.$options.filters.currency(car.balance, '₽'),
        'dayInMonth': car.dayInMonth,
        'tarifId': car.tarifName,
      };
      return valueByProp[prop];
    }

    printDate(date: string, withTime: boolean = true) {
      return date ? this.$options.filters.moment(date, `DD.MM.YYYY ${withTime ? 'HH:mm' : ''}`) : '';
    }

    prepareTable() {
      let headRow = '<tr>';
      this.dataProps.forEach((cell: any) => {
        headRow += `<td colspan="${cell.colspan ? cell.colspan : 1}"><b>${cell.label}</b></td>`
      });
      headRow += '</tr>';

      let bodyRows = '';
      this.carList.forEach(car => {
        bodyRows += '<tr>';
        this.dataProps.forEach((cell: any) => {
          const value = this.printCellValue(car, cell.prop);
          bodyRows += `<td colspan="${cell.colspan ? cell.colspan : 1}">${value ? value : ''}</td>`
        });
        bodyRows += '</tr>';
      });

      let table = `
      <table border="1">
        ${headRow}
        ${bodyRows}
      `;
      table += '</table>';

      return table;
    }

    printTable() {
      if (!this.carList.length) return;

      let mywindow = window.open('', 'PRINT', 'height=400,width=600');
      mywindow.document.write('<html><head></head><body >');

      let filterRow = ``;
      // if (filters.str) filterRow += `<br>Поиск: ${filters.str}`;
      // if (filters.corpId) filterRow += `<br>Корпорация: ${corps.find( corp => corp.id === filters.corpId).name}`;
      // if ((filters.dateBeg || filters.dateEnd) && (filters.dateBeg !== 'Invalid date' || filters.dateEnd !== 'Invalid date' )) {
      //   filterRow += `<br>Период: ${filters.dateBeg ? 'от ' + this.$options.filters.moment(filters.dateBeg, 'DD.MM.YYYY') : ''} ${filters.dateEnd ? 'до ' + this.$options.filters.moment(filters.dateEnd, 'DD.MM.YYYY') : ''}`;
      // }

      let table = `
      <h1>${this.fileName}</h1>
      <p>${filterRow ? (filterRow) : ''}</p>
      ${this.prepareTable()}
    `;
      mywindow.document.write(table);

      mywindow.document.write('</body></html>');
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    }

    prepareExcel() {
      const table = this.prepareTable();

      let uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; })
      };
      let downloadURI = function(uri, name) {
        let link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.click();
      };

      let ctx = {worksheet: this.fileName || 'Worksheet', table: table};
      let resuri = uri + base64(format(template, ctx));
      downloadURI(resuri, this.fileName);
    }

  }
